import SectionSecondary from './SectionSecondary'

export default SectionSecondary
